import api from './client.js'

export const teamsAPI = {
  list:         ()             => api.get('/teams'),
  mine:         ()             => api.get('/teams/mine'),
  get:          (id)           => api.get(`/teams/${id}`),
  create:       (data)         => api.post('/teams', data),
  update:       (id, data)     => api.patch(`/teams/${id}`, data),
  remove:       (id)           => api.delete(`/teams/${id}`),
  addMember:    (id, data)     => api.post(`/teams/${id}/members`, data),
  setRole:      (id, uid, r)   => api.patch(`/teams/${id}/members/${uid}`, { role: r }),
  removeMember: (id, uid)      => api.delete(`/teams/${id}/members/${uid}`),
  uploadLogo:   (id, file)     => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/teams/${id}/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  uploadBanner: (id, file)     => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/teams/${id}/banner`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  deleteBanner: (id)           => api.delete(`/teams/${id}/banner`),
  setBannerSource: (id, source) => api.put(`/teams/${id}/banner/source`, { source }),
  myInvites:      ()               => api.get('/teams/mine/invites'),
  teamRequests:   (id)             => api.get(`/teams/${id}/requests`),
  invite:         (id, user_id, message) => api.post(`/teams/${id}/invite`, { user_id, message }),
  joinRequest:    (id, message)    => api.post(`/teams/${id}/request`, { message }),
  respondInvite:  (inviteId, accept) => api.post(`/teams/invites/${inviteId}/respond`, { accept }),
  myPending:      ()               => api.get('/teams/mine/pending'),
}
